export const darkThemePaths = [
  '/',
  '/auctions',
  '/auctions/[auctionId]',
  '/auctions/[auctionId]/registration',
  '/auctions/[auctionId]/story',
  '/blackfriday',
  '/blackfridayfaq',
  '/blackfriday/[username]',
  '/blackfriday/blackout',
  '/blackfriday/trivia',
  '/blackfriday/trivia/[gameId]',
  '/blackfriday/trivia/[gameId]/lobby',
  '/brand/[slug]',
  '/manifesto',
  '/gift-cards/[uuid]',
  '/ja-jp/blackfriday/trivia/[gameId]',
  '/ja-jp/blackfriday/trivia/[gameId]/lobby',
  '/zh-cn/blackfriday/trivia/[gameId]',
  '/zh-cn/blackfriday/trivia/[gameId]/lobby',
];
